module.exports = __webpack_public_path__ + "static/img/Ellipse 108.d1489a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 108.png
// module id = cgJj
// module chunks = 1